<template>
    <j-modal :title="title" :width="modelStyle.width" :visible="visible" :bodyStyle="bodyStyle" :switchFullscreen="switchFullscreen" @ok="handleOk" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }" @cancel="handleCancel" cancelText="关闭">
        <yw-intelligent-patrol-report-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" @close="close"></yw-intelligent-patrol-report-form>
    </j-modal>
</template>

<script>
    import YwIntelligentPatrolReportForm from './YwIntelligentPatrolReportForm'
    export default {
        name: 'YwIntelligentPatrolReportModal',
        components: {
            YwIntelligentPatrolReportForm
        },
        data() {
            return {
                title: '',
                width: 800,
                visible: false,
                disableSubmit: false,
                switchFullscreen: true,
                bodyStyle: {
                    padding: "0",
                    height: (window.innerHeight * 0.8) + "px",
                    "overflow-y": "auto",
                },
                modelStyle: {
                    width: '60%',
                    style: { top: '20px' },
                    fullScreen: false
                }
            }
        },
        methods: {
            edit(record) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.realForm.edit(record);
                })
            },
            close() {
                this.$emit('close');
                this.visible = false;
            },
            handleOk() {
                this.$refs.realForm.submitForm();
            },
            submitCallback() {
                this.$emit('ok');
                this.visible = false;
            },
            handleCancel() {
                this.close()
            },
            /** 切换全屏显示 */
            handleClickToggleFullScreen() {
                let mode = !this.modelStyle.fullScreen
                if (mode) {
                    this.modelStyle.width = '100%'
                    this.modelStyle.style.top = '20px'
                } else {
                    this.modelStyle.width = '60%'
                    this.modelStyle.style.top = '50px'
                }
                this.modelStyle.fullScreen = mode
            },
        }
    }
</script>

